import { createTheme, ThemeProvider } from '@mui/material/styles';
import React, { Fragment, useState } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Footer from './components/Footer';
import Loader from './components/Loader';
import Navbar from './components/Navbar';
import { LoadContext } from './context/LoadContext';
import AnnotreeSearch from './pages/AnnotreeSearch';
import Application from './pages/Application';
import Example from './pages/Example';
import Home from './pages/Home';
import Upload from './pages/Upload';
// import AnnotoolFlow from "./pages/AnnotoolFlow";
//
// import SequenceQuery from "./pages/SequenceQuery";
import ScrollToTop from "./ScrollTop";

import GlobalStyle from './StyledGlobal';
import {ReactNotifications} from "react-notifications-component";
import FAQPage from "./pages/FAQPage/index";
import Tutorial from "./pages/Tutorial";

import {SERVER_PREFIX,SERVER_TYPE} from "./services/Config";
import Updates from "./pages/Updates";
import AnnotoolSearch from "./pages/AnnotoolSearch";
import Word2vec from "./pages/Word2vec";

const theme = createTheme({
  typography: {
    fontFamily: 'Montserrat',
  }
});

function App() {
    // load value is an int, 0 means not loading(default), 1 means annotree search stage 1
    // 2 means annotree search stage 2
  const [load, setLoad] =
      useState({
          "value":0,
          "token":"",
          "database":"",
          "path":""})

  return (
    <Fragment>
      <GlobalStyle />
      <ThemeProvider theme={theme}>
        <BrowserRouter basename={SERVER_PREFIX}>
            <ReactNotifications />
          {load['value'] ?
              // must be double: {{}}
              <LoadContext.Provider value={{load,setLoad}}>
                <Loader />
              </LoadContext.Provider>
            :
            <LoadContext.Provider value={{load, setLoad}}>
                <Navbar />
                <ScrollToTop />

                <Switch>
                    {/*<Route path= {"/annoview" + ""} exact component={Home} />*/}

                    <Route path= "/" exact component={Home} />
                    <Route path="/upload" component={Upload} />
                    <Route path="/annotree_search" component={AnnotreeSearch} />
                    <Route path="/app" component={Application} />
                    <Route path="/examples" component={Example} />
                    <Route path="/FAQ" component={FAQPage} />
                    <Route path="/annotool_search" component={AnnotoolSearch} />
                    <Route path="/tutorial" component={Tutorial} />
                    <Route path="/updates" component={Updates} />
                    <Route path="/model" component={Word2vec} />
                    {/*<Route path="/flow" component={AnnotoolFlow} />*/}
                    {/*<Route path="/sequence" component={SequenceQuery} />*/}
                </Switch>

              <Footer />
            </LoadContext.Provider>
          }
        </BrowserRouter>
      </ThemeProvider>
    </Fragment>
  )
}




export default App;
